import React from "react";
import { Button as ChakraButton } from "@chakra-ui/react";

import { CustomColorScheme } from "./types/CustomColorScheme";
import { BlueButton } from "./BlueButton";
import { RedButton } from "./RedButton";
import { GreenButton } from "./GreenButton";
import { IButtonProps } from "./types/IButtonProps";

interface IProps extends IButtonProps {}

// forwarRef potrzebny w przypadku kiedy trzeba oddać częściową kontrolę rodzicowi, tak jest w przypadku ToolTipa
const Button = React.forwardRef<HTMLButtonElement, IProps>(
  ({ customColorScheme, ...restProps }, ref) => {
    switch (customColorScheme) {
      case CustomColorScheme.Blue:
        return <BlueButton {...restProps} ref={ref} />;
      case CustomColorScheme.Red:
        return <RedButton {...restProps} ref={ref} />;
      case CustomColorScheme.Green:
        return <GreenButton {...restProps} ref={ref} />;
      default:
        return <ChakraButton {...restProps} ref={ref} />;
    }
  }
);

export { Button };
